/* tslint:disable */
/* eslint-disable */
/**
 * Properties API
 * API for managing properties
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateParcImmobilierCommandDto
 */
export interface CreateParcImmobilierCommandDto {
    /**
     * Libellé du parc
     * @type {string}
     * @memberof CreateParcImmobilierCommandDto
     */
    name: string;
    /**
     * Propriétaire (bailleur) du parc
     * @type {string}
     * @memberof CreateParcImmobilierCommandDto
     */
    ownerId: string;
    /**
     * Identifiants des biens à rattacher au parc
     * @type {Array<string>}
     * @memberof CreateParcImmobilierCommandDto
     */
    realEstateIds: Array<string>;
}

/**
 * Check if a given object implements the CreateParcImmobilierCommandDto interface.
 */
export function instanceOfCreateParcImmobilierCommandDto(value: object): value is CreateParcImmobilierCommandDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined) return false;
    if (!('realEstateIds' in value) || value['realEstateIds'] === undefined) return false;
    return true;
}

export function CreateParcImmobilierCommandDtoFromJSON(json: any): CreateParcImmobilierCommandDto {
    return CreateParcImmobilierCommandDtoFromJSONTyped(json, false);
}

export function CreateParcImmobilierCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateParcImmobilierCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'ownerId': json['ownerId'],
        'realEstateIds': json['realEstateIds'],
    };
}

export function CreateParcImmobilierCommandDtoToJSON(json: any): CreateParcImmobilierCommandDto {
    return CreateParcImmobilierCommandDtoToJSONTyped(json, false);
}

export function CreateParcImmobilierCommandDtoToJSONTyped(value?: CreateParcImmobilierCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'ownerId': value['ownerId'],
        'realEstateIds': value['realEstateIds'],
    };
}

